import { render } from "./Height.vue?vue&type=template&id=3b42e91f&scoped=true&ts=true"
import script from "./Height.vue?vue&type=script&lang=ts"
export * from "./Height.vue?vue&type=script&lang=ts"

import "./Height.vue?vue&type=style&index=0&id=3b42e91f&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b42e91f"]])

export default __exports__